import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import CurrentOperatorsListView from "./current";
import OperatorDashboards from "./dashboards";
import CurrentOperatorGroupsListView from "./groups/list";
import OperatorGroupAccessLevels from "./groups/access_levels";
import useAccessLevels from "../../../../hooks/use-access-levels";


const OperatorsViews = () => {
    const operatorAccessLevels = useAccessLevels();
    const location = useLocation();
    const history = useHistory();

    /**
     * Listens for the changes in location and with each change:
     * if the url of the website is the same as the base url of the operators, redirects to the list view of the operators.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.operators.base, exact: true})) {
            if (operatorAccessLevels.packages.base.operatorsList) {
                history.replace(routes.operators.list)
            } else if (operatorAccessLevels.packages.base.manageOperators) {
                history.replace(routes.operators.groups.base)
            } else {
                history.replace(routes.operators.base.concat(routes.error.accessDeniedForSection))
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.base.manageOperators, operatorAccessLevels.packages.base.operatorsList])

    return (
        <Switch>
            <Route path={routes.operators.base} exact/>
            {
                operatorAccessLevels.packages.base.operatorsList &&
                <Route path={routes.operators.list} exact>
                    <CurrentOperatorsListView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.base.manageOperators &&
                <Route path={routes.operators.groups.base} exact>
                    <CurrentOperatorGroupsListView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.base.manageAccessLevels &&
                <Route path={routes.operators.groups.single} exact>
                    <OperatorGroupAccessLevels/>
                </Route>
            }
            {
                operatorAccessLevels.packages.base.manageOperators &&
                operatorAccessLevels.packages.dashboard.systemWideDashboards &&
                <Route path={[routes.operators.dashboards.base, routes.operators.dashboards.single]} exact>
                    <OperatorDashboards/>
                </Route>
            }
            <Redirect to={routes.operators.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
};

export default OperatorsViews;
